import { render } from "./adView.vue?vue&type=template&id=2e8d4888&scoped=true&ts=true"
import script from "./adView.vue?vue&type=script&lang=ts&config=true"
export * from "./adView.vue?vue&type=script&lang=ts&config=true"

import "./adView.vue?vue&type=style&index=0&id=2e8d4888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8d4888"]])

export default __exports__